import { render } from "./UnreadMessagesNotification.vue?vue&type=template&id=2ac7d593&scoped=true"
import script from "./UnreadMessagesNotification.vue?vue&type=script&lang=js"
export * from "./UnreadMessagesNotification.vue?vue&type=script&lang=js"

import "./UnreadMessagesNotification.vue?vue&type=style&index=0&id=2ac7d593&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac7d593"]])

export default __exports__